import { BB_DETAILS } from "../../../../constants"

const From = () => {
  return (
    <div>
      <h4 className="font-medium text-neutral-400">From:</h4>
      <dl>
        <dt className="sr-only">company name</dt>
        <dd>{BB_DETAILS.name}</dd>
        <dt className="sr-only">address</dt>
        <dd>
          {BB_DETAILS.streetAddress}
          <br />
          {BB_DETAILS.city}, {BB_DETAILS.state} {BB_DETAILS.zipcode}
        </dd>
        <dt className="sr-only">phone</dt>
        <dd>{BB_DETAILS.phone}</dd>
        <dt className="sr-only">email</dt>
        <dd>{BB_DETAILS.email}</dd>
      </dl>
    </div>
  )
}

export default From
